var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer__container",class:_vm.$route.name === 'info' && 'footer__container--dark'},[_c('div',{staticClass:"footer__copyright"},[_vm._v("2023 Federico Cerati")]),_c('div',{staticClass:"footer__copyright"},[_vm._v("Henford Music")])])
}
var staticRenderFns = []

export { render, staticRenderFns }